var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C9.45 14 8.97933 13.8043 8.588 13.413C8.19667 13.0217 8.00067 12.5507 8 12V2C8 1.45 8.196 0.979335 8.588 0.588001C8.98 0.196668 9.45067 0.000668362 10 1.69492e-06C10.5493 -0.000664972 11.0203 0.195335 11.413 0.588001C11.8057 0.980668 12.0013 1.45134 12 2V12C12 12.55 11.8043 13.021 11.413 13.413C11.0217 13.805 10.5507 14.0007 10 14ZM2 14C1.45 14 0.979333 13.8043 0.588 13.413C0.196666 13.0217 0.000666667 12.5507 0 12V2C0 1.45 0.196 0.979335 0.588 0.588001C0.98 0.196668 1.45067 0.000668362 2 1.69492e-06C2.54933 -0.000664972 3.02033 0.195335 3.413 0.588001C3.80567 0.980668 4.00133 1.45134 4 2V12C4 12.55 3.80433 13.021 3.413 13.413C3.02167 13.805 2.55067 14.0007 2 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.89afe0185c115979c600a4d5c24b943d.svg";
export { ForwardRef as ReactComponent };